/** saarim.me is a Google Site, so only these hosts serve the app's routes. */
const SITE_HOSTS = new Set(['saarim.app', 'www.saarim.app']);

/** The route state that keeps a chat open when the visitor follows its link to another page. */
type AgentLinkState = { agentConversationId: string };

export function agentLinkState(conversationId: string | undefined): AgentLinkState | undefined {
  return conversationId ? { agentConversationId: conversationId } : undefined;
}

export function linkedConversationId(state: unknown): string | undefined {
  const id = (state as Partial<AgentLinkState> | null)?.agentConversationId;
  return typeof id === 'string' && id ? id : undefined;
}

/** The app path that a link points to, or undefined for a link that leaves the app. */
export function sitePath(href: string | undefined, origin: string = window.location.origin): string | undefined {
  if (!href) return undefined;
  let url: URL;
  try {
    url = new URL(href, origin);
  } catch {
    return undefined;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
  if (url.origin !== origin && !SITE_HOSTS.has(url.hostname)) return undefined;
  // The router reads a path that starts with // as another host.
  if (url.pathname.startsWith('//')) return undefined;
  return `${url.pathname}${url.search}${url.hash}`;
}
